"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");

var stream_1 = require("stream");

var xml = require("xml");
/**
 * A comunica sparql-results+xml Serialize Actor.
 */


var ActorSparqlSerializeSparqlXml =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeSparqlXml, _bus_sparql_serialize);

  function ActorSparqlSerializeSparqlXml(args) {
    _classCallCheck(this, ActorSparqlSerializeSparqlXml);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeSparqlXml).call(this, args));
  }
  /**
   * Converts an RDF term to its object-based XML representation.
   * @param {RDF.Term} value An RDF term.
   * @param {string} key A variable name, '?' must be included as a prefix.
   * @return {any} An object-based XML tag.
   */


  _createClass(ActorSparqlSerializeSparqlXml, [{
    key: "testHandleChecked",
    value: function () {
      var _testHandleChecked = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(['bindings', 'boolean'].indexOf(action.type) < 0)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle bindings streams or booleans.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testHandleChecked(_x, _x2) {
        return _testHandleChecked.apply(this, arguments);
      }

      return testHandleChecked;
    }()
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType, context) {
        var data, root, results, resultStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable();

                data._read = function () {
                  return;
                }; // Write head


                root = xml.element({
                  _attr: {
                    xlmns: 'http://www.w3.org/2005/sparql-results#'
                  }
                });
                xml({
                  sparql: root
                }, {
                  stream: true,
                  indent: '  ',
                  declaration: true
                }).on('data', function (chunk) {
                  return data.push(chunk + '\n');
                });

                if (action.type === 'bindings' && action.variables.length) {
                  root.push({
                    head: action.variables.map(function (v) {
                      return {
                        variable: {
                          _attr: {
                            name: v.substr(1)
                          }
                        }
                      };
                    })
                  });
                }

                if (!(action.type === 'bindings')) {
                  _context2.next = 14;
                  break;
                }

                results = xml.element({});
                root.push({
                  results: results
                });
                resultStream = action.bindingsStream; // Write bindings

                resultStream.on('error', function (e) {
                  data.emit('error', e);
                });
                resultStream.on('data', function (bindings) {
                  // XML SPARQL results spec does not allow unbound variables and blank node bindings
                  var realBindings = bindings.filter(function (v, k) {
                    return !!v && k.startsWith('?');
                  });
                  results.push({
                    result: realBindings.map(ActorSparqlSerializeSparqlXml.bindingToXmlBindings)
                  });
                }); // Close streams

                resultStream.on('end', function () {
                  results.close();
                  root.close();
                  data.push(null);
                });
                _context2.next = 28;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = root;
                _context2.next = 18;
                return action.booleanResult;

              case 18:
                _context2.t1 = _context2.sent;
                _context2.t2 = {
                  boolean: _context2.t1
                };

                _context2.t0.push.call(_context2.t0, _context2.t2);

                root.close();
                setImmediate(function () {
                  return data.push(null);
                });
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t3 = _context2["catch"](14);
                setImmediate(function () {
                  return data.emit('error', _context2.t3);
                });

              case 28:
                return _context2.abrupt("return", {
                  data: data
                });

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[14, 25]]);
      }));

      function runHandle(_x3, _x4, _x5) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }], [{
    key: "bindingToXmlBindings",
    value: function bindingToXmlBindings(value, key) {
      var xmlValue;

      if (value.termType === 'Literal') {
        var literal = value;
        xmlValue = {
          literal: literal.value
        };
        var language = literal.language;
        var datatype = literal.datatype;

        if (language) {
          xmlValue.literal = [{
            _attr: {
              'xml:lang': language
            }
          }, xmlValue.literal];
        } else if (datatype && datatype.value !== 'http://www.w3.org/2001/XMLSchema#string') {
          xmlValue.literal = [{
            _attr: {
              datatype: datatype.value
            }
          }, xmlValue.literal];
        }
      } else if (value.termType === 'BlankNode') {
        xmlValue = {
          bnode: value.value
        };
      } else {
        xmlValue = {
          uri: value.value
        };
      }

      return {
        binding: [{
          _attr: {
            name: key.substring(1)
          }
        }, xmlValue]
      };
    }
  }]);

  return ActorSparqlSerializeSparqlXml;
}(bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes);

exports.ActorSparqlSerializeSparqlXml = ActorSparqlSerializeSparqlXml;